import { CaptureSystem } from "@inovitas/infra3dsdk/dist/types/mm/api/utils/capturesystem";
import { Box } from "@mui/material";
import React from "react";

import { defaultStore } from "shared/common/stores/defaultStore";
import { CameraNode } from "shared/ui/cockpit/Cockpit";

interface props {
  cameras: CameraNode[];
  activeCamera: CaptureSystem | undefined;
  setHoverFrontCamera: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function IceCreamSwitcher({
  cameras,
  activeCamera,
  setHoverFrontCamera,
}: props) {
  const viewer = defaultStore((state) => state.viewer);

  return (
    <Box
      position={"absolute"}
      top={"-40%"}
      left={"-7px"}
      // paddingBottom={"4px"}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      gap={"4px"}
      sx={{ backgroundColor: "#e1e1e1", borderRadius: "14px" }}
      onMouseOver={() => setHoverFrontCamera(true)}
      onMouseOut={() => setHoverFrontCamera(false)}
    >
      <Box
        width="14px"
        height="14px"
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={"1px"}
        padding={"3px"}
        color={"secondary.main"}
        boxShadow={3}
        sx={{
          backgroundColor:
            activeCamera?.id === cameras[0].frame.capturesystemID
              ? "primary.main"
              : "white",
          "@media (hover: hover)": {
            ":hover": { backgroundColor: "secondary.main" },
          },
          borderRadius: "50%",
        }}
        onClick={() => {
          viewer?.moveToCamera(cameras[0].frame.capturesystemID);
        }}
      >
        <Box
          width="6px"
          height="6px"
          borderRadius={"4px"}
          sx={{ backgroundColor: "red" }}
        ></Box>
        <Box display={"flex"} flexDirection={"row"} gap={"2px"}>
          <Box
            width="6px"
            height="6px"
            borderRadius={"4px"}
            sx={{ backgroundColor: "blue" }}
          ></Box>
          <Box
            width="6px"
            height="6px"
            borderRadius={"4px"}
            sx={{ backgroundColor: "green" }}
          ></Box>
        </Box>
      </Box>
      <Box
        width="14px"
        height="14px"
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        gap={"1px"}
        padding={"3px"}
        boxShadow={3}
        color={"secondary.main"}
        sx={{
          backgroundColor:
            activeCamera?.id === cameras[1].frame.capturesystemID
              ? "primary.main"
              : "white",
          "@media (hover: hover)": {
            ":hover": { backgroundColor: "secondary.main" },
          },
          borderRadius: "50%",
        }}
        onClick={() => {
          viewer?.moveToCamera(cameras[1].frame.capturesystemID);
        }}
      >
        <Box
          width="6px"
          height="6px"
          borderRadius={"4px"}
          sx={{ backgroundColor: "black" }}
        ></Box>
        <Box
          width="4px"
          height="4px"
          borderRadius={"4px"}
          sx={{ backgroundColor: "white", border: "2px black solid" }}
        ></Box>
      </Box>
    </Box>
  );
}
